var Marionette = require('marionette'),
    Backbone = require('backbone'),
    Layout = require('./views/notesLayout'),
    State = require('./state/state'),
    fvChannel = require('glRadio').channel('FV'),
    NoteModelFactory = require('../notes/models/factory/factory'),
    NoteSettings = require('./settings'),
    CreatableNoteTypesHelper = require('./models/creatableNoteTypes'),
    SubApp = require('../common/SubApp');



var instVars = {
    notesCollection: null,
    region: null,
    state: null,
    vChannel: null,
    channel: null,
    layout: null, // the view hierarchy (layout)
    settings: null, // in progress -- pass w/out vChannel to modularize; now just hideActivityNotes
    creatableNoteTypesHelper: null
};


module.exports = Marionette.Object.extend({
    request: SubApp.prototype.request,
    command: SubApp.prototype.command,
    initialize: function(options, id) {

        _.extend( this, instVars, _.pick(options, '$container', 'vChannel', 'notesCollection'), {
           region: new Marionette.Region({ //( put in region -- note Layout set with onShow logic )
               el: options.$container
           }),
           channel: new Backbone.Radio.Channel('notes:' + id),
           settings: new NoteSettings({
               hideActivityNotes: options.hideActivityNotes
           })
        });

        var localStorage = fvChannel.request('localStorage');

        this.state = new State({
            channel: this.channel,
            hideActivityNotes: options.hideActivityNotes,
            sortType: localStorage.getLastNoteSortType(),
            sortDir: localStorage.getLastNoteSortDirection()
        });

        /*
        * If called from the viewer, this was already set (needed creating the layout), though no harm in setting it again.
        * Calling again to get filtering functionality to work with existing architecture -- filter is on notes.state,
        * which wouldn't work if the module is invoked independently from the viewer.
        * A better design may be to store filterState on the notesCollection, but that requires a larger refactor
        * and this is working fine for now.  It's somewhat done with 'sort' already. ((See base Notes Collection).
        * ( Determining whether notes are filtered is now done on the note UI models of the collection).
        * ( Could call command after communication is wired )
        * */
        this.notesCollection.setIsFiltered( this.state.filterState );

        /*
        * Set the sort direction and comparator (sortType) on the notesCollection
        * before it's rendered ( so it is rendered in the correct order ).
        * Don't call the update sort command after the channel is wired --
        * it's superflous we only want to set local storage values when the user changes them.
        * */
        this.notesCollection.updateSort( this.state.getSortType(), this.state.getSortDirection() );

        this.creatableNoteTypesHelper =
            new CreatableNoteTypesHelper()
                .initialize( this.vChannel, fvChannel.request('user') );


        this.layout = new Layout({
           channel: this.channel,
           notesCollection: this.notesCollection
        });

        this._wireCommunication();

   },
    /*
    *  Use as direct triggerOn after init -- its external.
    * */
    onRender: function() {
        this.region.show(this.layout);
    },
    _wireCommunication: function() {

        /* Because not a subapp -- extend */
        this.channel.reply(  _.extend( this.innerRequests(), this.outerRequests), this );
        this.channel.comply( _.extend( this.innerCommands, this.outerCommands ), this );

        /* inner event publisher but only listened to once */
        this.channel.once('notes:newNoteMenuRendered', _.bind(function(ddContent) {
            this.vChannel.trigger('notes:newNoteMenuRendered', ddContent, this.channel);
        }, this));

        Marionette.bindEntityEvents( this, this.channel, this.innerSubs );

        //TODO: generic -- listenAndForward...w/same name and arguments -- no extra logic applied
        var vCh = this.vChannel;
        _.each(this.outerPublishers, function(evt) {
            this.listenTo(this.channel, evt, function() {
                vCh.trigger.apply(vCh, [evt].concat( _.toArray(arguments)));
            });
        }, this);

    },
    outerRequests: {
        drawingAttributes: function() {
            return this.channel.request('drawingAttrs');
        },
 
        getNewNoteModel: function( isDocNote, noteType ) {
            return this.channel.request( 'newNoteModel', isDocNote, noteType );
        }
    },

    /**
     * (from vChannel)
     * could/should fwd some with same name ...
     */
    outerCommands: {
        pageImgLoadError: function(page) {

            this.channel.trigger('notes:updateNoteTypesToDisable', {
                fromPageLoadError: 1,
                page: page
            });

        },
        hoveredCanvasNoteChange: function() {
            var c = this.channel;
            c.trigger.apply(c, ['notes:hoveredCanvasNoteChange'].concat( _.toArray(arguments)) ); //TODO: fwd wrapper
        },
        canvasDrawingToggled: function() {
            var c = this.channel;
            c.trigger.apply(c, ['notes:canvasDrawingToggled'].concat( _.toArray(arguments)) );
        },
        activeNoteSubTypeChange: function(noteSubType, options) {

            var c = this.channel,
                activeNote = options.activeNote;

            // exiting ( we don't need to change the toolbar button)
            if (!activeNote) return;

            // Note: there could be other instances to avoid unnecessary calls to update the toolbar shape button,
            // but, doing so doesn't hurt anything so let it pass.
            // Previously, there was a noteType on the shapeToolbar prototypes and the button wasn't updated if:
            //      activeNote.getNoteType() !== this.noteType
            //      or this.activeItem === noteSubType
            //     ( basically, only change if the new value does not equal the last -- it could have changed already )
            // Removed to get rid of the noteType on the shapeToolbars (which can now have multiple noteTypes)

            c.command.apply(c, ['updateShapeToolbarBtn'].concat( _.toArray(arguments )) );

        },
        cancelSignature: function() {
            /* hack for signature, which can only be deleted, not modified */
            this.enterCancelChanges.apply(this, arguments); /* (same as from cancel click on view) */
        },
        activeNoteChange: function() {
            this.activeNoteChangeCB.apply(this, arguments);
        },
        expandedNoteChange: function() {
            this.expandedNoteChange.apply(this, arguments);
        },
        changePage: function(options) {

            this.channel.command('updateFilter', {
                filterSrc: 'pageChange',
                currentPage: options.page.get('number')
            });

            this.layout.updateOnPgChange(options);

        },
        viewModeChange: function(mode, options) {

            this.layout.updateOnViewModeChange.apply(this, arguments);

            this.channel.command('updateFilter', {
                filterSrc: 'modeChange',
                mode: this.channel.request('viewMode')
            });

        },
        togglePanelResize: function(isOn) {
            /* could really just pick the hover mod buttons, and hover shapes but more convenient to do all */
            this.channel.trigger('noteViews:toggleEventListeners', isOn);
        },
        createRedactionOnViewerLoad: function() {
            var c = this.channel;
            c.trigger( 'notes:changeActiveNote',
                c.request( 'newNoteModel', false, 'REDACTION_NOTE' ), {createNote: true}
            );
        }
    },
    //
    /**
     * this.channel --> this.vChannel
     * TODO: rid any overlap here
     */
    outerPublishers: [
        'notes:setActiveNote', 'notes:setExpandedNote', 'notes:goToPage', 'notes:toggleShapeHighlight', 'notes:noteSaved', 'notes:noteDeleted',
        'notes:setNoteSubType', 'notes:setDrawColor', 'notes:setDrawStrokeWidth', 'notes:graphicStampChanged'
    ],
    /* this.channel --> this.channel */
    /* no forward -- inner communication */
    innerSubs: {

        /* first 2: wrapper functions pre sending to note vent to viewer -- have all go through here, which then calls the publisher if necessary */
        'notes:changeActiveNote':          'triggerActiveNoteChange',   //***save, mod, cancel, del, etc ...
        'noteView:flashNoteDestruct':       '_deleteNote',   // the note being blown up is the active note -- was set on open ( delete called auto'ly, not from view )

        'notes:updateLastFlashPrId':        'updateLastFlashNtUser',
        'consultSelectView:groupsChanged':  'consultGroupChange',

        /* below forwarded from the note view */
        'noteView:enterSave':               'enterSaveNote',
        'noteView:enterCancel':             'enterCancelChanges',
        'noteView:enterEdit':               'enterEditNote',
        'noteView:enterDelete':             'enterDeleteNote',
        'noteView:enterExpand':             'expandNote',
        'noteView:convertToFloatingCodes':  'convertToFloatingCodes',

        'notes:updateNoteTypesToDisable':   'updateNoteTypesToDisable'


    },
    innerRequests: function() {

        var user = fvChannel.request('user'),
            vChannel = this.vChannel;

        return {
            /*
            * Returns the note model attributes that have changed, or
            * if none have changed, returns false ( like Backbone's changedAttributes ),
            * which is also called from this function.
            * */
            'notes:changedNoteAttributes': function(noteView) {

                // this should be on the view
                var note = noteView.model,
                    sanitizeNotesViewAttrs = note.sanitizeUserInput( noteView._getRawUserInput(), user ),

                    // if a drawable note and not changed, the text/shapes will be diff on the FIRST edit
                    // ... not sure if really matters (also think title is doing this)
                    changedAttrs = note.isDrawable()
                        ? note.hasNoteChanged( sanitizeNotesViewAttrs, vChannel.request('getAttributesToPersistOfNoteOnCanvas', note) )
                        : note.hasNoteChanged( sanitizeNotesViewAttrs ); //this condition here in case of image load failure

                /*
                * Hack --- should clean up ...
                * For graphic stamps, the text attribute is re-purposed as the stamp's id.
                * Return the stamp id if new or if the stamp image was swapped ( can tell from whether the image 'src' attr is present in changedAttrs )
                * */
                if ( note.isGraphicStamp() ) {

                    // text attribute -- do here b/c can tell if change from preceding hasNoteChanged call
                    if ( note.isNew() ) {

                        changedAttrs.text = note.uiModel.get('selectedStamp').get('id');

                    } else {

                        if ( _.has(changedAttrs, 'src') ) {
                            changedAttrs.text = note.uiModel.get('selectedStamp').get('id');
                        } else {
                            /*
                            * Another hack: there's definitely a better way to do this
                            * Must pass the text attribute as null to the java server.
                            * Currently at the point it's undefined and so wont be sent at all in the request body
                            * */
                            changedAttrs.text = null;
                        }
                    }
                }

                return changedAttrs;

            },
            'notes:getUserPrivateID': function () {
                return user.get('privateGrpId'); //todo make fn in other
            },
            'notes:getUserId': function () { //ACTUALLY, NEED ANYTHING FROM CORE?
                return user.getUserID();
            },
            vChannel: function () { /* Internal ref to vs --*/
                return vChannel;
            },
            noteIsActiveNote: function (note) {
                return vChannel.request('noteIsActiveNote', note);
            },
            currentPageNumber: function () {
                return vChannel.request('currentPageNumber');
            },

            newNoteModel: this.createNewNote,

            inEditMode: _.bind(this.state.inEditMode, this.state),

            filterState: function() {
                return this.state.filterState;
            },

            noteSortType: function() {
                return this.state.getSortType();
            },
            noteSortDirection: function() {
                return this.state.getSortDirection();
            },

            viewMode: function() {
                return vChannel.request('viewMode');
            },
            currentPageIsCold: function() {
                return vChannel.request('currentPage').isCold();
            },
            creatableNoteTypesHelper: function() {
                return this.creatableNoteTypesHelper;
            }


        };
    },
    innerCommands:  {

        updateSort: function(sortBy, dir) {

            var localStorage = fvChannel.request('localStorage');
            sortBy && localStorage.setLastNoteSortType( sortBy );
            dir && localStorage.setLastNoteSortDirection( dir );

            /* (changing comparator will trigger view update */
            this.notesCollection.updateSort.apply( this.notesCollection, arguments );
            this.command( 'changeSortIndicator', dir );

        },
        filterUpdated: function(filterModel) {

            this.notesCollection.setIsFiltered( filterModel );

            this.channel.command('updateNoteFilterInHeader'); // could pass the model in here
            this.channel.command('filterNoteViews', filterModel);

        }
    },

    triggerActiveNoteChange: function(note, options) {

        var opts = !options ? {} : options;
        this.vChannel.request('getViewer')
            ? this.channel.trigger('notes:setActiveNote', note, opts)
            : this.activeNoteChangeCB.apply( this, arguments ); // no longer necessary -- not making separate module ...

    },

    triggerExpandedNoteChange: function(note) {
        this.vChannel.request('getViewer')
            ? this.channel.trigger('notes:setExpandedNote', note)
            : this.expandedNoteChange(note); //todo could be in callback
    },
    expandNote: function(view, args) {
        this.triggerExpandedNoteChange(!args.model.uiModel.get('expanded') ? args.model : null);
    },
    activeNoteChangeCB: function(note, opts) { //'editMode' is true when activeNote is not null -- one is open; all others aren't

        this.state.set('activeNote', note); //(need to store for prior)

        var isNew = !opts.isEdit,
            actions = { //TODO: MAP THE ACTUAL OPTIONS TO COMMANDS (TRIGGER) -- though opts being used in other modules ..... don't break
                createNew : opts.createNote,  //model.save --> cb
                enterEditExisting: note !== null && !isNew && !opts.noteSaved, //entering
                saveNew: isNew && opts.noteSaved,
                editExisting: !isNew && opts.noteSaved,
                newCancelled : opts.userCancelled && isNew, //set to null
                editCancelled : note === null && opts.userCancelled && !isNew,
                editSavedButNoChanges: note === null && !isNew && opts.savedButNoChange,

                //(active note set when user opens flash note to read) -- this is for open/destroy, others handled like other
                isReadingFlashNote: opts.isReadingFlashNote,
                flashNoteDestructed: opts.flashNoteDestructed  // could have flash note cancelled if want to blow up; note: this doesn't apply when the blowup comes after the save of a nee note not create for the current user
            },
            actionOptions = _.extend( opts, {
                isNew: isNew && !opts.isReadingFlashNote, // only applicable if entering/exiting -- though should be new anyhow
                notes: this.notesCollection,
                note: note,
                prNote: this.state.previous('activeNote'),
                actions: actions,
                action: _.keys(actions)[ _.indexOf( _.values(actions), true )]
            });

        this.layout.updatePostActiveNoteChange(actionOptions);

    },
    expandedNoteChange: function(note) {
        this.state.set('expandedNote', note);
        this.layout.expandedNoteChange(note, this.state.previous('expandedNote'));
    },


    /**
     * Create and return a new note model:  elData - isdoc, noteType
     * Should clean ... isDocNote, noteType
     */
    createNewNote: function( isDocNote, noteType ) {

        var vCh = this.vChannel;

        /**
         * TODO: this is just a quick fix
         * - disallow the event to go through when doc no pages
         * - the actual menu item is disabled via css override
         * - still needed?
         */
        if ( vCh.request('activeDocHasNoPages') && !isDocNote )
            return false;


        var user = fvChannel.request('user'),
            defaultAccessGroup = user.defaultNoteAccessGroup( noteType === 'FLASH_NOTE' ),
            //store so can add to collection when created
            //attach this to avert Backbone making posts into puts  -- the model will have no ID; *** on save must give assign it an id
            attrs = {

                creationUser: user.getUserID(),
                creationUserDesc: user.getUserDescription(),
                accessGroup: defaultAccessGroup.id,
                accessGroupName: defaultAccessGroup.name,
                noteType: noteType,
                noteStatus: 'V'
            },
            newNoteOptions = {
                isNew: true,

                // parse necessary to set groupNoteType, otherwise, will encounter issue encountered in DVBC-1288
                // where the filter note menu will create a new line for the newly created note;
                // there's a better way to address -- the filter menu should probably be re-rendered on save
                // but it's working now and I'm afraid to break the workflow; maybe it was done this way on purpose
                // re-rendering of the entire notes view should be redone to make more understandable
                parse: true
            };


        // pg only attrs, options
        if (!isDocNote) {

            var currentPg = vCh.request('currentPage');

            // need this to create the url on save (don't set above & later delete if doc -- then if no pages & doc note choses --> err.
            _.extend( attrs, {
                pageId: currentPg.get('pageId')
            });

            // Necessary to override creating floating redaction on COLD pages
            currentPg.isCold() && _.extend( newNoteOptions, {
               isColdPage: currentPg.isCold()
            });

            // Send pageModel as options to create on parse to create Shape Models on the Note Model
            _.extend( newNoteOptions, {
                pageModel: currentPg
            });

        }

        var Note = NoteModelFactory.factory( noteType , isDocNote ),
            newNoteModel = new Note( attrs, newNoteOptions );

        newNoteModel['pageNumber'] = isDocNote
            ? 0
            : vCh.request('currentPageNumber');  //if doc note: no page associated with the model (0 for sorting) // TODO : put on model inst. (but is it known?)

        /* flash notes: the change the default accessGroup, accessGroupName to that of the last opened -- should work for flash back to, call when openened*/
        //TODO: set above in attrs

        var lastOpenedFlashNotePrvGroupId = this.state.get('lastOpenedFlashNotePrvGroupId');
        if (newNoteModel.isFlashNote() && lastOpenedFlashNotePrvGroupId) {
            newNoteModel.set({
                accessGroup: lastOpenedFlashNotePrvGroupId /* on render will select from list */
                /*note: don't need description -- will get from ui on save (dropdown) */
                /*  accessGroupName: FV.user.privateGroups.findWhere({groupId: 2000}).get('description') */

            });
        }
        return newNoteModel;

    },

    /*
    * Wait: wait for server before removing from collection -- that handler removes the view -- (if error, don't remove it).
    * will run success/err after remove event
    * */
    _deleteNote: function(note) {

        note.destroy({
            wait: true,
            success: _.bind( this._deleteNoteSuccess, this ),
            error: _.bind (this._deleteNoteError, this )
        });

    },
    _deleteNoteSuccess: function(note) {

        this.vChannel.trigger('alert:show', {
            type: 'info',
            shortMessage: 'Note Deleted',
            closeTimeout: 3000
        });

        this.channel.command('updateFilter', {
            filterSrc: 'noteDeleted'
        });

        // TODO: all the above (and below) should be triggered a listener to this event ( and do the same for save )
        this.channel.trigger('notes:noteDeleted', note);

        this.channel.trigger('notes:updateNoteTypesToDisable'); // (now must do after notes have been added to the page collections )


    },
    _deleteNoteError: function(model, jqXHR) {

        this.vChannel.command('ajaxError', jqXHR, 'Error deleting note');

    },

    /*
    *  Called on destroy of the last flash note.
    *  TODO: on open ???
    * */
    updateLastFlashNtUser: function(flashNote) {
        this.state.set('lastOpenedFlashNotePrvGroupId', flashNote.get('creationUserPrivateGroup'));
    },

    enterSaveNote: function(view) {

        var m = view.model;

        if ( this._disallowSaveOrCancelChanges(m) )
            return;

        /*
        * attrsToSave: really the changedNoteAttributes or false if none changed, passed to Backbone.Model.save.
        * ( contains the attrs we'd like to change ).
        * Note -- a complete representation of the resource will be sent back from the server
        * ( and if successful, they're 'set' back on the model, so only attributes that changed will be altered ).
        * {wait: true}: implemented with DVBC-1628 -- this waits to set the attributes on the model
        * until after they're returned from the server ( it also prevents an extra validate call from 'set',
        * and setting model attributes to null if validation fails from 'set' ).
        * However, Backbone.Model.save still attempts to validate the attributes prior to sending them to the server
        * ( and it also does so after they are returned ).
        * */
        var isNew = m.isNew(),
            attrsToSave = this.channel.request('notes:changedNoteAttributes', view),
            saveOptions = {
                isNew: isNew,
                success: _.bind( this._noteSaveSuccess, this ),
                error: _.bind( this._noteSaveFailure, this ),
                wait: true
            },
            isNode = fvChannel.request('settings').isRunningNode;

        /**
         * DVBC-1762 - if creating shape models on parse of the note model
         * ( which will be called on saved; now only for full page redactions ),
         *  model parse requires the pageModel of the note to create the Shape UI Model,
         *  which now derived from the page collection.
         *  ( TODO: the reference should be broken from the Shape Model; pageId should be enough ).
         */

        if ( m.isDrawable() ) {

            _.extend( saveOptions, {
                pageCollection: this.channel.request('vChannel').request('activeDocPages')
            });

        }

        if (isNew) {

            /*
             * Url: force to use this url -- its not a part of the document notes collection.
             * TODO: stop inheriting the url of the model from the collection or set it's url on create
             */
            if ( m.isFlashNote() && m.parentFlashBackNote ) {

                _.extend( saveOptions, {
                    url: _.result( this.vChannel.request('docNotes'), 'url')
                });

            }

            if ( m.isGraphicStamp() ) {

                /**
                 * For Graphic Stamps, never send the src attribute to the Java server to cut down on payload / processing (its not needed).
                 * The node test server needs this to know the source of the image to read back in (it doesn't have a db).
                 * This is another hack that should be cleaned up.
                 * For now detecting if node from the port (above) -- there is no webpack environment variable.
                 * Alternative is using (PRODUCTION), but that is messier b/c we could run a prod build in node.
                 * Same logic goes for modify, below.
                 */
                !isNode && _.has( attrsToSave, 'src' ) && ( delete attrsToSave.src );

                /**
                 * Hack: for node server send the graphicStamp header from the selectedStamp -- since its new, like 'src' its not yet on the model
                 * Not necessary to send Java environment.
                 * Code here b/c already checking node environment
                 */

                isNode && ( attrsToSave['graphicStampHeader'] = m.uiModel.getSelectedStampImgHeader() );

            }

            /**
             * DVBC-1299 - hook in here to change the default autoDisplay for page text notes to NULL
             * ( they are initially set to 'V' in the default attributes of create new note ).
             * NULL implies the same meaning as 'V' for Doc Viewer.
             * Hacky and not the clearest way to accomplish, but definitely the quickest
             * given existing codebase, especially since we don't give the user the option to change this value,
             * and it has no meaning for this application, only FDD ( a window opens on document load ).
             * FDD will interpret NULL the same as 'I'.
             * Alternatives approaches involve changing the default for the note type (now set in 'createNewNote'),
             * and handling the it differently when put into and read out from the noteView in the save process (_getRawUserInput).
             * This is only for new notes -- leave edited ones with the same value.
             * A change here is definitely something to consider with a refactor / further sub-classing.
             * Also, nly do if noteStatus is 'V' just in case this ever changes.
             */
            if ( m.isPageTextNote() && m.get('noteStatus') ==='V' ) {
                attrsToSave['noteStatus'] = null;
            }


            m.save( attrsToSave, saveOptions );

        } else {

           if ( attrsToSave !== false ) {

               // DVBC-1299: if page text note and noteStatus is null, set attribute to save back to null.
               // ( It will have been changed when retrieving the the value printed in the UI ).
               if ( m.isPageTextNote() && m.get('noteStatus') === null ) {
                   attrsToSave['noteStatus'] = null;
               }


               // if converting to floating redaction, change the note type before save
               // ( on success it will be reset from the server and read in as the floating note type )
               if ( m.isRedactionNoteConvertingToFloatingCodes() ) {
                    m.set('noteType', 'FLOATING_REDACTION_NOTE');
               }

               // If modifying a floating redaction note and the system flag is off,
               // Switch the note type so the server will pick up and save as a regular redaction note.
               if ( m.isFloatingRedactionAndSystemNotSetForFloatingCodes() ) {
                   m.set('noteType', 'REDACTION_NOTE');
               }

               if ( m.isGraphicStamp() && !isNode ) {

                   // Backbone Model save will still send the original attributes, not just the changed ones (by design)
                   // (src would always exist for existing models)
                   // hack here taking it off is much simpler the over-writing model.save
                   m.unset( 'src', {silent:true} );

                   // with the src attr now an obj at all rotations, on modify it will be different than the original model
                   // we never want to send it to the Java server (and maybe now not the node server ... )
                   // for simplicity, the src retrieved from that canvas stamp model is just that of the current stamp (a single string, not the entire object)
                   // so, it will now appear in changed attributes; ensure it's removed (as with newly created stamps)
                   _.has(attrsToSave, 'src') && ( delete attrsToSave.src );

               }

               m.save( attrsToSave, saveOptions );

           } else {

               // Nothing changed -- reset the ui: same as 'editCancelled';
               this.channel.trigger('notes:changeActiveNote', null, {
                   savedButNoChange: true,
                   isEdit: !isNew
               });
           }

        }

    },
    enterCancelChanges: function(view, args) {

        // Quick hack for signature cancel mediation (model passed instead)
        if (!(arguments[0] instanceof Backbone.View)) {
            var model = view.uiModel.parent,
                view = this.channel.request('getNoteViewFromModel', model);
        }

        var m = view.model;

        if ( this._disallowSaveOrCancelChanges(m) )
            return;

        var isNew = m.isNew(),
            setActiveNoteOpts = {
                userCancelled: true,
                isEdit: !isNew
            },
            channel = this.channel,
            exitNoteEditing = function() {
                m.resetOnCancelChanges();
                channel.trigger('notes:changeActiveNote', null, setActiveNoteOpts);
            },
            opts = {
                m: m,
                exitNoteEditing: exitNoteEditing,
                isDrawable: m.isDrawable(),
                modalOpts: {
                    confirmType: 'warning',
                    title: 'Confirm',
                    okCB: exitNoteEditing
                }
            };

        isNew
            ? this._cancelCreateNote(opts)
            : this._cancelModifyNote(opts, view);

    },
    /*
    * Disallow save/cancel of note if user is drawing a shape ( DVBC-1497 manifests for polygon redactions ).
    * First predicate unnecessary but provided for clarity.
    * DVBC-1498: exception -- proceed when graphic text area view is being edited: the unsaved view will be destroyed on completion.
    * */
    _disallowSaveOrCancelChanges: function(note) {
        return note.isDrawable() && note.uiModel.get('isUserDrawingShape')
            && this.channel.request('vChannel').request('activeNoteSubType') !== 'text';
    },

    /*
    * For drawable notes show a warning dialog.
    * For new notes there are always 'changes'.
    * */
    _cancelCreateNote: function(opts) {

        !opts.isDrawable
            ? opts.exitNoteEditing()
            : this.vChannel.trigger('modal:open',
                _.extend( opts.modalOpts, {
                    content: 'Cancel New ' + opts.m.desc + ' Note?'
                })
        );
    },
    /*
    * If nothing changed, don't ask to save.
    * Otherwise: change the ui back to the orig values: if drawable-- show a conformation dialog first.
    * */
    _cancelModifyNote: function( opts, view ) {

        var attrsToSave = this.channel.request('notes:changedNoteAttributes', view);

        if (attrsToSave === false) {  // ( returns false or that the attrs have changed )
            opts.exitNoteEditing();
            /*
             * Return: don't allow exitNoteEditing again !!!
             * ( This would set the activeNote twice, causing errors --
             *  although its null each time, sometimes we need to refer to the previous activeNote
             *  in the higher level function's logic )
             */
            return;
        }

        !opts.isDrawable
            ? opts.exitNoteEditing()
            : opts.modal = this.vChannel.trigger( 'modal:open', _.extend( opts.modalOpts, {
                content: 'Cancel ' + opts.m.desc + ' Note Modifications?'
            }));

    },
    _noteSaveSuccess: function(note, resp, options) {

        this.vChannel.trigger('alert:show', {
            type: 'success',
            shortMessage: options.isNew ? 'Note Created' : 'Note Modified',
            closeTimeout: 3000
        });


        /*
        * If Flash Back --
        * Listen for the destroy of the view with the model -- will only be one to one --- it's now the active note.
        * For note saved here there is no active note ... need to save note.parentFlashBackNote to the collection view
        * w/out affecting the active note (if access group is the current user ONLY).
        * */
        var prtFbNt = note.parentFlashBackNote;
        if (prtFbNt) {

            var user = fvChannel.request('user');

            // The exit: should remove it from the view and resume destroy countdown.
            // TODO: facade -- also not going top down.
            prtFbNt.uiModel.set('replyMode', false);

            // Need to check user id but ensure fetched first (would occur if create new flash note not yet selected
            user.gettingPrivateGroups().done( _.bind(function(groups) {

                if ( note.get('accessGroup') === user.getPrivateGroup().get('groupId') )
                    this.notesCollection.add( note, { // will draw
                        at: 0
                    });

            }, this));
            // TODO: fail

        } else {

            // TODO: combo with the below -- they overlap
            this.channel.trigger('notes:changeActiveNote', null, {
                noteSaved: true,
                isEdit: !options.isNew
            });
        }


        this.channel.command('updateFilter', {
            filterSrc: 'noteSaved'
        });

        // If flash note, want added to doc note collection, so it updates
        this.channel.trigger('notes:noteSaved', note);

        // Note: must now come after the above -- TODO: like delete -- have the above flow from the top level down
        this.channel.trigger( 'notes:updateNoteTypesToDisable' );

    },

    _noteSaveFailure: function(note, jqXHR, options) {

        note.trigger('notes:noteSaveFailure', note, jqXHR, options );

        // Now showing in a viewer dialog -- not in the note 'error line' ( no longer concerned with a separate notes model )
        this.vChannel.command( 'ajaxError', jqXHR, 'Error ' + (options.isNew ? 'creating' : 'modifying') + ' note' );


    },
    enterEditNote: function(view, args) {
        this.channel.trigger( 'notes:changeActiveNote', args.model, {isEdit: true} );
    },
    /*
    * Note: N/A for flash notes.
    * Locking is handled server side, but to be friendly, don't allow the user to see the modal
    * if the document is locked by another user.  (I already have the code for it).
    * */
    enterDeleteNote: function(view) {

        var note = view.model,
            showDeleteNoteModal = _.bind( function() {

                this.vChannel.trigger( 'modal:open', {
                    confirmType: 'warning',
                    title: 'Confirm',
                    content: 'Delete Note?',
                    okCB: _.bind( function() {
                        this._deleteNote( note );
                    }, this)
                });

            }, this );


        if ( note.isPageNote() ) {
            this.vChannel.command( 'checkActiveDocLockStatus', 'Delete Note', showDeleteNoteModal, 0, 0, 1 );
            return;
        }

        showDeleteNoteModal();

    },

    consultGroupChange: function( note ) {

        if ( note.supportsColorPicker() ) {

            // Note: was off this.channel, but only want listeners of the current view ( now there is a toolbar or textStamp views )
            note.trigger( 'colorPicker:toggleEnabled', note );
        }

        this.vChannel.trigger( 'notes:consultGroupChange', note );

    },

    // convert a redaction note (from the model) to use floating reason codes
    convertToFloatingCodes: function(view, args) {

        // Set isConvertingToFloatingCodes flag on the note model
        // Among other things, this will change how the shapeViews and shapeModel will render on the canvas (see canvas.activeNoteChange)
        var note = args.model;
        note.isConvertingToFloatingCodes = true;

        /*
        * Trigger an activeNote change to hook into existing architecture for setting the active note.
        * Only allowing the call this way (when the note isn't already active, also avoids
        * Issue of dealing with newly created / modified shapes if 'convert was' clicked in edit mode.
        * */
        this.channel.trigger('notes:changeActiveNote', args.model, {
            isEdit: true
        });
    },

    /**
     * ** Now central point of access ***
     * See creatableNoteTypesHelper.updateNoteTypesToDisable for notes here.
     * Update the state of note types that can be created, then update the new notes menus.
     */
    updateNoteTypesToDisable: function( options ) {

        var noteTypeToDisable =
            this.creatableNoteTypesHelper.updateNoteTypesToDisable( this.vChannel, options );

        this.channel.trigger( 'newNoteMenu:setDisabledMenuItems',
            noteTypeToDisable, this.creatableNoteTypesHelper.disableNewNoteMenus() );

    },

    onBeforeDestroy: function() {
       this.channel.reset();
       _.invoke([  this.state, this.layout], 'destroy'); // TODO: the instance variables
   }

});




/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/notes.js
 ** module id = 484
 ** module chunks = 0
 **/